import { render, staticRenderFns } from "./s02.vue?vue&type=template&id=6a34ab54"
import script from "./s02.vue?vue&type=script&lang=js"
export * from "./s02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports